import React from "react";
import { TitleCardContent } from "./internals/components/TitleCardContent";
import { Grid2 as Grid, Typography } from "@mui/material";
import { pxToRem } from "../../utils/fontSizeUtility";
import { useTheme } from "../../platform-style";

const LAYOUT_TOGGLE_STORAGE_KEY = "ENABLE_ALTERNATE_LAYOUT";
const useAlternateLayout = localStorage.getItem(LAYOUT_TOGGLE_STORAGE_KEY) === "true";

interface TitleCardProps {
  id: string;
  title: string | JSX.Element;
  titleCardScreenPosition?: TitleCardScreenPosition;
  underlineTitle?: boolean;
  height?: string;
  elevation?: number;
  children?: JSX.Element;
}

interface TitleCardScreenPosition {
  topMarginInPx?: string;
  bottomMarginInPx?: string;
  leftMarginInPx?: string;
  rightMarginInPx?: string;
}

export const TitleCard = (props: TitleCardProps) => {
  const theme = useTheme();
  return (
    <TitleCardContent elevation={props.elevation ?? 1}>
      <Grid
        container
        id={props.id}
        direction={"column"}
        alignItems={"flex-start"}
        justifyContent={"center"}
        spacing={1}
        paddingTop={pxToRem(16)}
        sx={{
          height: props.height ?? "",
          width: "100%",
          marginTop: props.titleCardScreenPosition?.topMarginInPx ?? "0px",
          marginBottom: props.titleCardScreenPosition?.bottomMarginInPx ?? "0px",
          marginRight: props.titleCardScreenPosition?.rightMarginInPx ?? "0px",
          marginLeft: props.titleCardScreenPosition?.leftMarginInPx ?? "0px",
          "&& .MuiGrid-item": {
            paddingLeft: "0",
          },
        }}
      >
        <Grid width={"100%"}>
          <Typography
            variant={useAlternateLayout ? "headlineSmall" : "h5"}
            data-testid={"testHeader_" + props.id}
            borderBottom={props.underlineTitle ? `1px solid ${theme.palette.divider}` : "0px"}
            marginRight={"24px"}
            paddingBottom={"8px"}
            paddingLeft={useAlternateLayout ? "0px" : "16px"}
            display={"block"}
          >
            {props.title}
          </Typography>
          {props.children}
        </Grid>
      </Grid>
    </TitleCardContent>
  );
};
